module.exports = __webpack_public_path__ + "static/media/Moon_Sine.30249a0a.png";